import React, { useContext, useEffect, useState } from 'react';
import { ScreensContext } from '../contexts/screensContext';
import MenuScreen from '../common/menu-screen';
import styles from '../components/lm-d-s/index.module.scss';
import InfoScreen from '../components/lm-d-s/info-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import ChallengeScreen from '../components/lm-d-s/challenge-screen';
import QuizScreen from '../components/lm-d-s/quiz-screen';
import FinalQuizScreen from '../components/lm-d-s/final-quiz-screen';
import FinalScreen from '../components/lm-d-s/final-screen';
import LmLineScreen from '../components/lm-d-s/lm-line-screen';
import QuizChallenge from '../common/challenge-component/quiz-challenge';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import AllBrandsScreen from '../common/all-brands-screen';
import BrandLineScreen from '../common/brand-line-screen';
import PredictionScreen from '../common/prediction-screen';
import FactoryScreen from '../common/factory-screen';
import CommerceVideoScreen from '../components/commerce-video-screen/CommerceVideoScreen';
import CharacteristicScreen from '../components/lm-d-s/characteristic-screen';
import { getImageFromS3 } from '../imageService';
import ReviewFlowScreen from '../common/review-flow-screen';
import FindYourCocktailChallenge from '../common/challenge-component/find-your-cocktail-challenge';
import WhatKindOfResearcher from '../common/challenge-component/what-kind-of-researcher';
import { CURRENT_CHALLENGE_NAME } from '../consts/challengeName';
import useScreenHistory from '../hooks/useScreenHistory';

const menu = [
  {
    id: 'challenge',
    screenNumber: 15,
    name: CURRENT_CHALLENGE_NAME,
    icon: '/images/lm-double-splash/may-challenge-menu-icon.svg'
  },
  {
    id: 'foresight',
    screenNumber: 9,
    name: 'Передбачення на сьогодні',
    icon: 'images/lm-double-splash/foresight-menu-icon.svg'
  },
  {
    id: 'characteristic',
    screenNumber: 4,
    name: 'Характеристики сигарет',
    icon: '/images/lm-double-splash/characteristic-menu-icon.svg'
  },
  {
    id: 'info',
    screenNumber: 3,
    name: 'Все про Філіп Морріс Україна',
    icon: '/images/lm-double-splash/info-menu-icon.svg'
  },
  {
    id: 'factory',
    screenNumber: 2,
    name: 'Нова фабрика на Львівщині',
    icon: '/images/lm-double-splash/authority-menu-icon.svg'
  },
  {
    id: 'review',
    screenNumber: 12,
    name: 'Залишити відгук про продукт',
    icon: '/images/lm-double-splash/review-menu-icon.svg'
  }
];

const selectedPack = {
  title: 'Marlboro Purple',
  pack: getImageFromS3('images/packs/marlboro/purple.png'),
  tobaccoFirst: 'Вміст смол, мг - 4',
  tobaccoSecond: 'Вміст нікотину, мг - 0.3',
  filterIcon: getImageFromS3('images/marlboro/filter.png'),
  background: `url("${getImageFromS3(
    'images/marlboro/purple-background.png'
  )}")`,
  isNewMixture: true,
  newMixtureText: 'Оновлена тютюнова суміш',
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- King Size Super Slim ("Кінг сайз супер слім")'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  filterCharacteristicList: [
    {
      description: (
        <span>
          Ущільнений ацетатний фільтр, який краще тримає форму та менше розмокає
        </span>
      ),
      bordered: false
    }
  ]
};

const MLBPrpl = () => {
  const toReviewButton = sessionStorage.getItem('r_b') === 'true';
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: toReviewButton ? 12 : -2,
      initialState: { brandLine: '' }
    });
  const brandLine = historyState.brandLine || '';
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('MLB-Prpl');
    sendEvent('age_verification_without');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case -2: {
        return (
          <CommerceVideoScreen
            videoSrc={getImageFromS3('videos/mlb-prpl.mp4')}
            setScreenNumber={cb}
            nextScreenNumber={1}
            changeScreenImmediately
            skipScreenImmediately
            controls
            buttonStyle="skip-video"
            hasButtonArrow
          />
        );
      }
      case -1: {
        return (
          <AllBrandsScreen
            setScreenNumber={cb}
            setBrandLine={(brand) => {
              setScreenNumber(16, false, { brandLine: brand });
            }}
            handleBackButton={() => setScreenNumber(4, true)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 1: {
        return (
          <MenuScreen
            setScreenNumber={cb}
            menuList={menu}
            backgroundImage={`url("${getImageFromS3(
              'images/marlboro/purple-background.png'
            )}")`}
            blackStyle
          />
        );
      }
      case 2: {
        return (
          <FactoryScreen
            setScreenNumber={cb}
            backButtonClick={() => setScreenNumber(1, true)}
            nextButtonClick={() => setScreenNumber(10)}
          />
        );
      }
      case 3: {
        return (
          <InfoScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(10)}
          />
        );
      }
      case 4: {
        return (
          <CharacteristicScreen
            brandId="marlboro"
            style="mlb-prpl"
            isNewMixture={selectedPack?.isNewMixture}
            title={selectedPack?.title}
            newMixtureText={selectedPack?.newMixtureText}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={selectedPack?.filterCharacteristicList}
            infoList={selectedPack?.characteristicInfoList}
            tobaccoFirst={selectedPack?.tobaccoFirst}
            tobaccoSecond={selectedPack?.tobaccoSecond}
            packImage={selectedPack?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(10)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={selectedPack?.background}
            filterIcon={selectedPack?.filterIcon}
            characteristicListTitle={selectedPack?.characteristicListTitle}
            nextButtonTitle="Далі"
          />
        );
      }
      case 5: {
        return <ChallengeScreen setScreenNumber={cb} />;
      }
      case 6: {
        return <QuizScreen setScreenNumber={cb} />;
      }
      case 7: {
        return <QuizScreen setScreenNumber={cb} />;
      }
      case 8: {
        return <FinalQuizScreen setScreenNumber={cb} />;
      }
      case 9: {
        return (
          <PredictionScreen
            setScreenNumber={setScreenNumber}
            handleBackButton={() => setScreenNumber(1, true)}
          />
        );
      }
      case 10: {
        return <FinalScreen setScreenNumber={cb} withReviewButton />;
      }
      case 11: {
        return <FinalScreen setScreenNumber={cb} />;
      }
      case 12: {
        return (
          <ReviewFlowScreen
            setScreenNumber={cb}
            setSubmitReviewScreenNumber={() => setScreenNumber(11)}
            innerScreenNumber={historyState.innerScreenNumber}
            setInnerScreenNumber={(val) =>
              setScreenNumber(12, false, { innerScreenNumber: val })
            }
          />
        );
      }
      case 13: {
        return <LmLineScreen setScreenNumber={cb} />;
      }
      case 14: {
        return (
          <QuizChallenge
            setScreenNumber={setScreenNumber}
            type="which-are-you-a-leader"
            backgroundImage={`url("${getImageFromS3(
              'images/marlboro/purple-background.png'
            )}")`}
            resultTitleFontSize={24}
          />
        );
      }
      case 15: {
        return (
          <FindYourCocktailChallenge
            backgroundImage={`url("${getImageFromS3(
              'images/marlboro/purple-background.png'
            )}")`}
            setScreenNumber={setScreenNumber}
            afterResultButtonScreen={() => setScreenNumber(10)}
          />
        );
      }
      case 16: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(-1, true)}
            nextButtonClick={() => setScreenNumber(10)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <div className={styles.pageContainer} id="marlboro-purple-screen-container">
      <div className={styles.contentContainer}>
        <ScreensContext.Provider
          value={{
            endSessionType,
            setEndSessionType,
            isDisplayedAll,
            setIsDisplayedAll
          }}
        >
          {getScreen(screenNumber, setScreenNumber)}
        </ScreensContext.Provider>
      </div>
    </div>
  );
};

export default MLBPrpl;
